/* tslint:disable */
export enum RoleDto {
  Owner = 'Owner',
  Administrator = 'Administrator',
  FittingApproval = 'FittingApproval',
  User = 'User',
  None = 'None'
}
